import ChoiceTreeComponent from './choicetree';

export default ChoiceTreeComponent;
export const ChoiceTree = ChoiceTreeComponent;
export * from './utils';
